if (!customElements.get("sticky-atc")) {
  class StickyATC extends HTMLElement {
    constructor() {
      super({
        name: "Sticky ATC",
        version: "2.0.0",
      });
    }

    connectedCallback() {
      this.stickyATCUpper = document.querySelector(".section-main-product");

      if (!this.stickyATCUpper) return;

      this.button = this.querySelector("[data-sticky-atc-btn]");

      document.documentElement.style.setProperty("--footer-offset", `${this.offsetHeight}px`);

      new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.3 }).observe(this.stickyATCUpper);

      this.button.addEventListener("click", this.onClickHandler.bind(this));
    }

    disconnectedCallback() {
      if (!this.stickyATCUpper) return;

      // disconnect IntersectionObserver
      const observer = new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.3 });
      observer.unobserve(this.stickyATCUpper);
    }

    handleUpperIntersect(entries, observer) {
      this.colorSelector = this.querySelector(".product__color-selector");
      this.variantSelector = this.querySelector(".product__variant-selector");

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // hide when scrolling up
          document.querySelector("sticky-atc").style.transform = "translateY(calc(100% + var(--space-24)))";
          document.body.classList.remove("sticky-atc-visible");
        } else {
          // show when scrolling down
          document.querySelector("sticky-atc").style.transform = "translateY(0)";
          document.body.classList.add("sticky-atc-visible");
        }
      });
    }

    onClickHandler(event) {
      event.preventDefault();

      const target = document.querySelector(".buy-block-wrapper");
      if (!target) return;

      const rect = target.getBoundingClientRect();

      const scrollTop = window.pageYOffset;
      const elementBottom = rect.bottom + scrollTop;

      const viewportHeight = window.innerHeight;

      const offset = 20;

      const targetScroll = elementBottom - viewportHeight + offset;

      window.scrollTo({
        top: targetScroll,
        behavior: "smooth",
      });
    }
  }

  customElements.define("sticky-atc", StickyATC);
}
